import styled from 'styled-components';

const StolenBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: ${({ theme }) => theme.colors.alert};
  width: 100%;
  padding: 10px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
`;

export default StolenBanner;
